export default __webpack_public_path__ + "static/media/pickupTime.5e45d1b9.svg";